export const GET_USER_LOADING = "get/user/loading"
export const GET_USER_ERROR = "get/user/error"
export const GET_USER_SUCCESS = "get/user/success"

export const PATCH_USER_LOADING = "patch/user/loading"
export const PATCH_USER_ERROR = "patch/user/error"
export const PATCH_USER_SUCCESS = "patch/user/success"

